/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Picker_SearchInputs */

const vi_product_lot_picker_search = /** @type {(inputs: Product_Lot_Picker_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gõ mã lô hoặc tên sản phẩm...`)
};

/**

* @param {Product_Lot_Picker_SearchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_picker_search = /** @type {((inputs?: Product_Lot_Picker_SearchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Picker_SearchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_picker_search(inputs)
});